/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';
import Footer from '../../Components/Footer';
import Header from '../../Components/Header';
import UpdateProfile from '../../Containers/UpdateProfile';

const EditProfile = () => {
  return (
    <div className='profile-page'>
      <Header />
      <main>
        <div className='profile pr'>
          <div className='container'>
            <div className='row'>
              <UpdateProfile />
            </div>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};
export default EditProfile;
